import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  registerMotoristaRequest: ['motorista'],
  registerMotoristaSuccess: null,

  updateMotoristaRequest: ['motorista', 'values'],
  updateMotoristaSuccess: null,

  getAllMotoristaRequest: null,
  getAllMotoristaSuccess: ['motoristas'],

  deleteMotoristaRequest: ['id'],
  deleteMotoristaSuccess: null,

  requestMotoristaFailure: ['error'],
});

const INITIAL_STATE = { motoristas: [], loading: false, error: '' };

/**
 * REGISTER REQUESTS BELLOW
 */

const registerMotoristaRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const registerMotoristaSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});

/**
 * UPDATE REQUESTS BELLOW
 */

const deleteMotoristaRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const deleteMotoristaSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});
/**
 * UPDATE REQUESTS BELLOW
 */

const updateMotoristaRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const updateMotoristaSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});

/**
 * GET SERVICES
 */

const getAllMotoristaRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
  motoristas: [],
});

const getAllMotoristaSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  error: '',
  loading: false,
  motoristas: action.motoristas,
});

/**
 * Request falure
 */
const requestMotoristaFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  error: action.error,
  loading: false,
});

export default createReducer(INITIAL_STATE, {
  [Types.REGISTER_MOTORISTA_REQUEST]: registerMotoristaRequest,
  [Types.REGISTER_MOTORISTA_SUCCESS]: registerMotoristaSuccess,

  [Types.REQUEST_MOTORISTA_FAILURE]: requestMotoristaFailure,

  [Types.UPDATE_MOTORISTA_REQUEST]: updateMotoristaRequest,
  [Types.UPDATE_MOTORISTA_SUCCESS]: updateMotoristaSuccess,

  [Types.DELETE_MOTORISTA_REQUEST]: deleteMotoristaRequest,
  [Types.DELETE_MOTORISTA_SUCCESS]: deleteMotoristaSuccess,

  [Types.GET_ALL_MOTORISTA_REQUEST]: getAllMotoristaRequest,
  [Types.GET_ALL_MOTORISTA_SUCCESS]: getAllMotoristaSuccess,
});
